module.exports = __webpack_public_path__ + "static/hero8-750d9c8e632e36157fe52a9920936fd8.webp";